//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const CacheDataTableLookupResults: FeatureFlag = {"Id":"CacheDataTableLookupResults","Label":"[10.18]Cache Data Table lookup results","Impact":"Cache data table lookup results to avoid repeated calculation calls for the same data. Only needed when 'Always skip DisplayIfOtherHasValue rendering when hidden' is enabled.","Mode":0,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
